/**
 * @generated SignedSource<<dba768e73d87212c33ae1034a1c463fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateUserPasswordInput = {
  currentPassword: string;
  newPassword: string;
};
export type Profile_updateUserPassword_Mutation$variables = {
  input: UpdateUserPasswordInput;
};
export type Profile_updateUserPassword_Mutation$data = {
  readonly updateUserPassword: {
    readonly user: {
      readonly id: string;
    };
  } | null;
};
export type Profile_updateUserPassword_Mutation = {
  response: Profile_updateUserPassword_Mutation$data;
  variables: Profile_updateUserPassword_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserPasswordPayload",
    "kind": "LinkedField",
    "name": "updateUserPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Profile_updateUserPassword_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Profile_updateUserPassword_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "23c51bd5d9d3b1b728cd51380aa4dda4",
    "id": null,
    "metadata": {},
    "name": "Profile_updateUserPassword_Mutation",
    "operationKind": "mutation",
    "text": "mutation Profile_updateUserPassword_Mutation(\n  $input: UpdateUserPasswordInput!\n) {\n  updateUserPassword(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f54003880fefccc449629dc3eef24fd";

export default node;
